import { __assign } from "tslib";
import React from "react";
import Button from "@adsk/alloy-react-button";
import Tooltip from "@adsk/alloy-react-tooltip";
import { useTranslations } from "../utils";
import { FeatureFlag } from "../shared/constants";
import { useFeatureFlag } from "../shared/components/LaunchDarklyContext";
var buttonStyle = {
  marginRight: 10,
  whiteSpace: "nowrap",
};
export var CreateTemplateButton = function (props) {
  var T = useTranslations().T;
  var isMaintenanceMode = useFeatureFlag(
    FeatureFlag.PL_PROJECT_TEMPLATES_MAINTENANCE_MODE,
    false
  ).value;
  return isMaintenanceMode
    ? React.createElement(
        Tooltip,
        {
          placement: Tooltip.PLACEMENTS.TOP,
          content: T.translate(
            "createProjectTemplateButton.templateMaintenanceMode"
          ),
        },
        React.createElement(
          Button,
          __assign({ style: buttonStyle, disabled: true }, props)
        )
      )
    : React.createElement(Button, __assign({ style: buttonStyle }, props));
};
